/**
 * Set/update a cookie value
 * @param name Name of the cookie
 * @param value Value for the cookie
 */
export default function setOrUpdateCookie(name, value) {
    document.cookie = name + "=" + (value || "") + "; path=/;";
}
/**
 * Set/update the "_culture" cookie value
 * @param value Value for the "_culture" cookie
 */
export function setCultureCookieValue(value) {
    return setOrUpdateCookie("_culture", value);
}
/**
 * Get the "_culture" cookie value
 */
export function getCultureCookieValue() {
    var cookieValue = document.cookie.replace(/(?:(?:^|.*;\s*)_culture\s*\=\s*([^;]*).*$)|^.*$/, "$1");
    return cookieValue;
}
/**
 * Get the "SuomiFiResponse" cookie value
 */
export function getSuomiFiCookieValue() {
    var cookieValue = document.cookie.replace(/(?:(?:^|.*;\s*)SuomiFiResponse\s*\=\s*([^;]*).*$)|^.*$/, "$1");
    return cookieValue;
}
